var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIncidentAog = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6.46,11.18 A 7,7 0 1,1 12.82,16.69",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.55,14.96 L 21.66,18.07 A 1.17,1.17 0 0,1 20.01,19.72 L 16.9,16.62",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.3,5.25 C 13.82,5.25 14.23,5.76 14.23,6.47 L 14.23,8.92 L 17.49,10.76 L 17.49,11.78 L 14.23,10.85 L 14.23,12.9 L 15.25,13.71 L 15.25,14.53 L 13.31,14.01 L 11.38,14.53 L 11.38,13.71 L 12.4,12.9 L 12.4,10.85 L 9.13,11.78 L 9.13,10.76 L 12.4,8.92 L 12.4,6.47 C 12.4,5.76 12.81,5.25 13.32,5.25 L 13.3,5.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.11,13.02 A 0.97,0.97 0 0,1 7.77,13.02 L 11.75,19.82 A 0.97,0.97 0 0,1 10.92,21.28 L 2.96,21.28 A 0.97,0.97 0 0,1 2.13,19.82 L 6.11,13.02",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.94,15.55 L 6.94,17.68",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.94,19.63 L 6.95,19.63",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIncidentAog, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/incident-aog.1e23fafb.svg";
export { ForwardRef as ReactComponent };